import React, { useState, useEffect } from "react";
import Axios from "axios";
import { baseUrl } from "../../config";
import { Table, Divider, Tag } from "antd";
import { Link } from "react-router-dom";
import "./styles.scss";

const columns = [
  {
    title: "Tarih",
    dataIndex: "date",
    key: "date",
    width: "20%",
    sorter: (a, b) => a.date - b.date,
    render: (text, render) => <p>{render.date}</p>,
  },
  {
    title: "Ad Soyad",
    dataIndex: "name",
    key: "name",
    width: "14%",
    render: (text, render) => (
      <p>
        {render.name} {render.surname}
      </p>
    ),
  },
  {
    title: "Sepet Tutari",
    dataIndex: "totalPrice",
    key: "totalPrice",
    width: "15%",
    render: (text, render) => <p>{render.totalPrice} TL</p>,
  },
  {
    title: "Kargo Bedeli",
    dataIndex: "totalPrice",
    key: "totalPrice",
    width: "15%",
    render: (text, render) => <p>12.00 TL</p>,
  },
  {
    title: "Toplam Fiyat",
    dataIndex: "totalPrice",
    key: "totalPrice",
    width: "15%",
    render: (text, render) => (
      <p>{parseFloat(render.totalPrice) + parseFloat(12.0)}</p>
    ),
  },
  {
    title: "Il",
    dataIndex: "il",
    key: "il",
  },
  {
    title: "Odeme Durumu",
    dataIndex: "status",
    key: "status",
    filters: [
      {
        text: "Basarili",
        value: "basarili",
      },
      {
        text: "Odeme Bekliyor",
        value: "odemebekliyor",
      },
    ],
    onFilter: (value, record) => record.status.indexOf(value) === 0,
    render: (text, render) => (
      <Tag color={render.status === "basarili" ? "green" : "orange"}>
        {render.status}
      </Tag>
    ),
  },
  {
    title: "Kargo Durumu",
    dataIndex: "cargoStatus",
    key: "cargoStatus",
    filters: [
      {
        text: "Kargoda",
        value: "kargoyaverildi",
      },
      {
        text: "kargobekliyor",
        value: "",
      },
    ],
    onFilter: (value, record) => record.cargoStatus.indexOf(value) === 0,
    render: (text, render) => (
      <Tag color={render.cargoStatus === "kargoyaverildi" ? "green" : "orange"}>
        {render.cargoStatus}
      </Tag>
    ),
  },
  {
    key: "action",
    render: (text, record) => (
      <div>
        <span>
          <Link to={`/orders/details/${record._id}`}>
            <div
              style={{
                width: "100px",
                height: "40px",
                backgroundColor: "#0fb9b1",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "5px",
                boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.12)",
              }}
            >
              <span style={{ color: "#fff", fontSize: "14px" }}>Detay </span>
            </div>
          </Link>
          <Divider type="vertical" />
          <Link to={`/orders/edit/${record._id}`}>
            <div
              style={{
                width: "100px",
                height: "40px",
                backgroundColor: "#fa8231",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "5px",
                boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.12)",
              }}
            >
              <span style={{ color: "#fff", fontSize: "14px" }}>Kargo </span>
            </div>
          </Link>
        </span>
      </div>
    ),
  },
];

function App(props) {
  const [response, setResponse] = useState([]);

  useEffect(() => {
    Axios.get(baseUrl + "order")
      .then((response) => {
        setResponse(response.data);
      })
      .catch(function (error) {});
  }, []);

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          padding: "50px 0",
        }}
      >
        <Link to="/">
          <div
            style={{
              width: "150px",
              height: "50px",
              backgroundColor: "#27ae60",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "5px",
              boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.12)",
            }}
          >
            <span style={{ color: "#fff", fontSize: "15px" }}>
              Yeni Siparis Oluştur
            </span>
          </div>
        </Link>
      </div>
      <Table key={"allProductsTable"} columns={columns} dataSource={response} />
    </div>
  );
}

export default App;
